// ---------------------------------------------------------------------------
// deepFreeze helper
// ---------------------------------------------------------------------------
function deepFreeze(value) {
    if (value !== null && typeof value === "object") {
        Object.freeze(value);
        for (const child of Object.values(value)) {
            deepFreeze(child);
        }
    }
    return value;
}
// ---------------------------------------------------------------------------
// Registry entries (MSE001–MSE020)
// All modulePaths verified against packages/core/src/ at PR74 time.
// ---------------------------------------------------------------------------
export const SMART_SHIKKA_MODULE_SIZE_EXPORT_ENTRIES = deepFreeze([
    // PR68 — Code Review Engine Foundation
    {
        id: "MSE001",
        modulePath: "code-review/codeReviewTypes.ts",
        moduleName: "Code Review Types",
        category: "types",
        maxLineCount: 300,
        maxExportCount: 20,
        limitKind: "both",
        severity: "error",
        introducedInPr: 68,
        active: true,
        rationale: "Types-only file; must stay concise",
    },
    {
        id: "MSE002",
        modulePath: "code-review/codeReviewRuleCatalog.ts",
        moduleName: "Code Review Rule Catalog",
        category: "registry",
        maxLineCount: 600,
        maxExportCount: 15,
        limitKind: "both",
        severity: "error",
        introducedInPr: 68,
        active: true,
        rationale: "Rule catalog registry; bounded scope",
    },
    // PR69 — Safe Patch Preview and Test Generation Planner
    // Lives in code-assistant/ module (safe-patch-preview/ does not exist as a separate module)
    {
        id: "MSE003",
        modulePath: "code-assistant/patchPreviewTypes.ts",
        moduleName: "Patch Preview Types",
        category: "types",
        maxLineCount: 300,
        maxExportCount: 20,
        limitKind: "both",
        severity: "error",
        introducedInPr: 69,
        active: true,
        rationale: "Types-only file; must stay concise",
    },
    {
        id: "MSE004",
        modulePath: "code-assistant/testGenerationPlanner.ts",
        moduleName: "Test Generation Planner",
        category: "evaluator",
        maxLineCount: 500,
        maxExportCount: 15,
        limitKind: "both",
        severity: "warn",
        introducedInPr: 69,
        active: true,
        rationale: "Planner logic; warn if growing large",
    },
    // PR70 — Browser Control Safety Readiness Gate
    {
        id: "MSE005",
        modulePath: "browser-control/browserControlTypes.ts",
        moduleName: "Browser Control Types",
        category: "types",
        maxLineCount: 300,
        maxExportCount: 20,
        limitKind: "both",
        severity: "error",
        introducedInPr: 70,
        active: true,
        rationale: "Types-only file; must stay concise",
    },
    {
        id: "MSE006",
        modulePath: "browser-control/browserActionReadinessGate.ts",
        moduleName: "Browser Action Readiness Gate",
        category: "policy",
        maxLineCount: 500,
        maxExportCount: 15,
        limitKind: "both",
        severity: "error",
        introducedInPr: 70,
        active: true,
        rationale: "Gate policy; bounded scope",
    },
    // PR72 — Coverage Gate and Safety Test Matrix
    {
        id: "MSE007",
        modulePath: "coverage-gate/coverageGateTypes.ts",
        moduleName: "Coverage Gate Types",
        category: "types",
        maxLineCount: 300,
        maxExportCount: 20,
        limitKind: "both",
        severity: "error",
        introducedInPr: 72,
        active: true,
        rationale: "Types-only file; must stay concise",
    },
    {
        id: "MSE008",
        modulePath: "coverage-gate/coverageGatePolicy.ts",
        moduleName: "Coverage Gate Policy",
        category: "policy",
        maxLineCount: 500,
        maxExportCount: 15,
        limitKind: "both",
        severity: "error",
        introducedInPr: 72,
        active: true,
        rationale: "Policy registry; bounded scope",
    },
    {
        id: "MSE009",
        modulePath: "coverage-gate/safetyTestMatrix.ts",
        moduleName: "Safety Test Matrix",
        category: "registry",
        maxLineCount: 400,
        maxExportCount: 15,
        limitKind: "both",
        severity: "warn",
        introducedInPr: 72,
        active: true,
        rationale: "Test matrix; warn if growing large",
    },
    {
        id: "MSE010",
        modulePath: "coverage-gate/coverageGateEvaluator.ts",
        moduleName: "Coverage Gate Evaluator",
        category: "evaluator",
        maxLineCount: 400,
        maxExportCount: 15,
        limitKind: "both",
        severity: "error",
        introducedInPr: 72,
        active: true,
        rationale: "Evaluator; must not grow unbounded",
    },
    // PR73 — Generated Redaction Policy Registry
    {
        id: "MSE011",
        modulePath: "redaction-policy/redactionPolicyTypes.ts",
        moduleName: "Redaction Policy Types",
        category: "types",
        maxLineCount: 300,
        maxExportCount: 15,
        limitKind: "both",
        severity: "error",
        introducedInPr: 73,
        active: true,
        rationale: "Types-only file; must stay concise",
    },
    {
        id: "MSE012",
        modulePath: "redaction-policy/redactionPolicyRegistry.ts",
        moduleName: "Redaction Policy Registry",
        category: "registry",
        maxLineCount: 600,
        maxExportCount: 15,
        limitKind: "both",
        severity: "error",
        introducedInPr: 73,
        active: true,
        rationale: "Registry with 20 patterns + 14 policies; bounded",
    },
    {
        id: "MSE013",
        modulePath: "redaction-policy/redactionPolicyEvaluator.ts",
        moduleName: "Redaction Policy Evaluator",
        category: "evaluator",
        maxLineCount: 300,
        maxExportCount: 10,
        limitKind: "both",
        severity: "error",
        introducedInPr: 73,
        active: true,
        rationale: "Evaluator; must not grow unbounded",
    },
    {
        id: "MSE014",
        modulePath: "redaction-policy/redactionPolicyReportModel.ts",
        moduleName: "Redaction Policy Report Model",
        category: "report_model",
        maxLineCount: 200,
        maxExportCount: 10,
        limitKind: "both",
        severity: "warn",
        introducedInPr: 73,
        active: true,
        rationale: "Report model; warn if growing large",
    },
    // PR74 — Module Size and Public Export Guard (self-referential entries)
    {
        id: "MSE015",
        modulePath: "module-size-export-guard/moduleSizeExportGuardTypes.ts",
        moduleName: "Module Size Export Guard Types",
        category: "types",
        maxLineCount: 300,
        maxExportCount: 15,
        limitKind: "both",
        severity: "error",
        introducedInPr: 74,
        active: true,
        rationale: "Types-only file; must stay concise",
    },
    {
        id: "MSE016",
        modulePath: "module-size-export-guard/moduleSizeExportGuardRegistry.ts",
        moduleName: "Module Size Export Guard Registry",
        category: "registry",
        maxLineCount: 600,
        maxExportCount: 10,
        limitKind: "both",
        severity: "error",
        introducedInPr: 74,
        active: true,
        rationale: "Registry with 20 entries; bounded",
    },
    {
        id: "MSE017",
        modulePath: "module-size-export-guard/moduleSizeExportGuardEvaluator.ts",
        moduleName: "Module Size Export Guard Evaluator",
        category: "evaluator",
        maxLineCount: 300,
        maxExportCount: 10,
        limitKind: "both",
        severity: "error",
        introducedInPr: 74,
        active: true,
        rationale: "Evaluator; must not grow unbounded",
    },
    {
        id: "MSE018",
        modulePath: "module-size-export-guard/moduleSizeExportGuardReportModel.ts",
        moduleName: "Module Size Export Guard Report Model",
        category: "report_model",
        maxLineCount: 200,
        maxExportCount: 10,
        limitKind: "both",
        severity: "warn",
        introducedInPr: 74,
        active: true,
        rationale: "Report model; warn if growing large",
    },
    // General core index entries
    {
        id: "MSE019",
        modulePath: "coverage-gate/index.ts",
        moduleName: "Coverage Gate Index",
        category: "index",
        maxLineCount: 30,
        maxExportCount: 0,
        limitKind: "line_count",
        severity: "warn",
        introducedInPr: 74,
        active: true,
        rationale: "Index files should be thin re-export wrappers",
    },
    {
        id: "MSE020",
        modulePath: "redaction-policy/index.ts",
        moduleName: "Redaction Policy Index",
        category: "index",
        maxLineCount: 30,
        maxExportCount: 0,
        limitKind: "line_count",
        severity: "warn",
        introducedInPr: 74,
        active: true,
        rationale: "Index files should be thin re-export wrappers",
    },
]);
// ---------------------------------------------------------------------------
// Registry object
// ---------------------------------------------------------------------------
export const SMART_SHIKKA_MODULE_SIZE_EXPORT_GUARD_REGISTRY = deepFreeze({
    entries: SMART_SHIKKA_MODULE_SIZE_EXPORT_ENTRIES,
    generatedInPr: 74,
    liveExecutionPerformed: false,
    networkCallMade: false,
    dbWriteMade: false,
});
// ---------------------------------------------------------------------------
// Accessor helpers
// ---------------------------------------------------------------------------
export function getModuleSizeExportEntryById(id) {
    return SMART_SHIKKA_MODULE_SIZE_EXPORT_ENTRIES.find((e) => e.id === id);
}
export function getModuleSizeExportEntryByPath(modulePath) {
    return SMART_SHIKKA_MODULE_SIZE_EXPORT_ENTRIES.find((e) => e.modulePath === modulePath);
}
export function getActiveModuleSizeExportEntries() {
    return SMART_SHIKKA_MODULE_SIZE_EXPORT_ENTRIES.filter((e) => e.active);
}
export function getEntriesByPr(pr) {
    return SMART_SHIKKA_MODULE_SIZE_EXPORT_ENTRIES.filter((e) => e.introducedInPr === pr);
}
export function getEntriesByCategory(category) {
    return SMART_SHIKKA_MODULE_SIZE_EXPORT_ENTRIES.filter((e) => e.category === category);
}
//# sourceMappingURL=moduleSizeExportGuardRegistry.js.map